import { ReactNode, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { isRtl } from 'utils/constants/app/rtl';
import { ModalPadding, ZINDEX_HIGH_1 } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { Modal, ModalButtons } from 'components/Modal';
import { Button } from 'newcomponents/UI/Button';

type modalProps = {
  title?: string;
  text: string;
  icon?: {
    lib: string;
    name: string;
    theme: string;
  };
  successBtn: {
    text: string;
    onClick: Function;
  };
  cancelBtn?: {
    text: string;
    onClick?: Function;
  };
  closable?: boolean;
};
const initialModalsValue: [] = [];
let currentModals: { id: number; modal: ReactNode }[] | [] = initialModalsValue;

let globalSetModals = (data: { id: number; modal: ReactNode }[] | []): void => {
  console.error(
    `you must usePopup before setting its state ${data[0].id ?? ''}`
  );
};

let globalModalAlert = (data: modalProps): void => {
  console.error(`you must usePopup before setting its state ${data}`);
};

const _removeFromModal = (id: number) => {
  if (!currentModals.length) {
    return;
  }

  const index = currentModals?.findIndex(item => item?.id === id);
  const res = [...currentModals];
  res.splice(index, 1);
  globalSetModals(res);
};

export const usePopup = singletonHook(initialModalsValue, () => {
  const [modals, setModals] = useState<{ id: number; modal: ReactNode }[] | []>(
    initialModalsValue
  );

  globalSetModals = data => {
    currentModals = data;
    setModals(data);
  };

  globalModalAlert = (data: modalProps) => {
    const id = modals?.length ? modals?.length + 1 : 1;
    const closable = data.closable ?? true;

    const modal = (
      <Modal
        maxWidth={isMobile() ? '350px' : '420px'}
        title={data.title}
        visible={true}
        closable={closable}
        maskClosable={closable}
        key={id}
        centered
        wrapperPadding={
          isMobile() ? ModalPadding.MOBILE_12 : ModalPadding.DESKTOP_24
        }
        onCancel={() => {
          _removeFromModal(id);
        }}
        zIndex={ZINDEX_HIGH_1}
        image={
          data.icon
            ? { ...data.icon }
            : { lib: 'generic', name: 'attentionGeneric', theme: 'colored' }
        }
      >
        <div className="modalText">
          <span>{data.text}</span>
        </div>
        <ModalButtons>
          {!!data.cancelBtn && (
            <Button
              type="cancel"
              size="large"
              onClick={() => {
                data.cancelBtn?.onClick && data.cancelBtn.onClick();
                _removeFromModal(id);
              }}
            >
              {data.cancelBtn.text}
            </Button>
          )}
          <Button
            style={{ [`margin${isRtl ? 'Right' : 'Left'}`]: '8px' }}
            type="primary"
            size="large"
            onClick={() => {
              data.successBtn.onClick();
              _removeFromModal(id);
            }}
          >
            {data.successBtn.text}
          </Button>
        </ModalButtons>
      </Modal>
    );

    const item = {
      id: id,
      modal: modal
    };

    const res = modals?.length ? [...modals, item] : [item];

    globalSetModals(res);
  };

  currentModals = modals;

  return modals;
});

export const modalAlert = (data: modalProps) => globalModalAlert(data);
